<template>
    <div id="certificacao-bloco-informacoes">
        <el-skeleton :loading="carregando" animated>
            <template #template>
                <div class="skeleton-bloco-informacoes__interno">
                    <el-skeleton-item class="icone" variant="circle" />
                    <div class="width-interno">
                        <el-skeleton-item variant="p" />
                        <el-skeleton-item class="width-interno" variant="p" />
                    </div>
                    <el-skeleton-item class="numero" variant="rect" />
                </div>
            </template>
            <template #default>
                <slot />
            </template>
        </el-skeleton>
    </div>
</template>

<script>
export default {
    name: 'BlocoInformacaoCertificacaoSkeleton',
    props: {
        carregando: {
            type: Boolean,
            default: () => false
        }
    }
};
</script>

<style lang="scss" scoped>
#certificacao-bloco-informacoes {
    .width-interno {
        width: 50%;
    }

    flex-wrap: wrap;
    & > div {
        flex-grow: 1;
    }

    .skeleton-bloco-informacoes__interno {
        min-height: 89px;
        min-width: 19vw;
        border-radius: 10px;
        background: #d6d6d6;
        display: flex;
        align-items: center;
        justify-content: space-around;

        .icone {
            width: 28px;
            height: 28px;
        }

        .numero {
            width: 10%;
            height: 30px;
        }
    }
}

@media only screen and (max-width: 1380px) {
    #certificacao-bloco-informacoes {
        min-width: 32.2% !important;
        flex-grow: 0;
    }
}
</style>
